import update from 'immutability-helper'


const defaultState = {
  page: 0,
  count: 0,
  data: [],
  casting: null,
}


export default function castings(state = defaultState, action) {
  switch (action.type) {
    case 'GET_CASTINGS': return {
      ...state,
      page: 0,
      count: 0,
      data: [],
    }

    case 'GET_CASTINGS_SUCCESS': return {
      ...state,
      data: action.data,
    }

    case 'CREATE_CASTING_SUCCESS': return {
      ...state,
      data: [action.data].concat(state.data),
    }

    case 'GET_CASTING_SUCCESS': return {
      ...state,
      casting: action.data,
    }

    case 'EDIT_CASTING_SUCCESS': return {
      ...state,
      casting: {
        ...state.casting,
        ...action.data,
      },
    }

    case 'EDIT_CASTING_PROFILE_SUCCESS': return {
      ...state,
      casting: update(state.casting, {
        profiles: {
          [state.casting.profiles.findIndex(p => p.objectID === action.profile.id)]: {
            $set: {
              ...state.casting.profiles.findIndex(p => p.objectID === action.profile.id),
              ...action.profile,
            },
          },
        },
      }),
    }

    default: return state
  }
}
